import { ErrorBoundary } from 'react-error-boundary';
import { captureException } from '@sentry/react-router';

import { ReviewsSection as ReviewsSectionModule, type ReviewsSectionProps } from '@cx-modules/reviews-section';

export const ReviewsSection = (props: ReviewsSectionProps) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      captureException(error);
      return null;
    }}
  >
    <ReviewsSectionModule {...props} />
  </ErrorBoundary>
);
